import React, { useState } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateSocialMediaIconsTabData,socialMediaIconsTabData }) => {
    const [iconSizeType, setIconSizeType] = useState(socialMediaIconsTabData.icon_size);
    const [locationType, setLocationType] = useState(socialMediaIconsTabData.location_type);
    const [positionType, setPositionType] = useState(socialMediaIconsTabData.position_type);

    // Handle Icon Size Type change
    const handleIconSizeTypeChange = (event) => {
        setIconSizeType(event.target.value);
        updateSocialMediaIconsTabData("icon_size", event.target.value);
    };

    // Handle Location Type change
    const handleLocationTypeChange = (event) => {
        setLocationType(event.target.value);
        updateSocialMediaIconsTabData("location_type", event.target.value);
    };

    // Handle Position Type change
    const handlePositionTypeChange = (event) => {
        setPositionType(event.target.value);
        updateSocialMediaIconsTabData("position_type", event.target.value);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Layout</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <p>Icon Size</p>
                    <div className="left-cnater-right-button mb-0">
                        <label className="card-radio-btn">
                            <input type="radio" name="icon_size_type" className="card-input-element d-none" value="24px" onChange={handleIconSizeTypeChange} checked={iconSizeType === "24px"} />
                            <div className="card card-body">
                                <div className="content_sub">24px</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="icon_size_type" className="card-input-element d-none" value="32px" onChange={handleIconSizeTypeChange} checked={iconSizeType === "32px"} />
                            <div className="card card-body">
                                <div className="content_sub">32px</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="icon_size_type" className="card-input-element d-none" value="40px" onChange={handleIconSizeTypeChange} checked={iconSizeType === "40px"} />
                            <div className="card card-body">
                                <div className="content_sub">40px</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="icon_size_type" className="card-input-element d-none" value="48px" onChange={handleIconSizeTypeChange} checked={iconSizeType === "48px"} />
                            <div className="card card-body">
                                <div className="content_sub">48px</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="icon_size_type" className="card-input-element d-none" value="60px" onChange={handleIconSizeTypeChange} checked={iconSizeType === "60px"} />
                            <div className="card card-body">
                                <div className="content_sub">60px</div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <p>Location</p>
                    <div className="left-cnater-right-button mb-0">
                        <label className="card-radio-btn">
                            <input type="radio" name="location_type" className="card-input-element d-none" value="inline" onChange={handleLocationTypeChange} checked={locationType === "inline"} />
                            <div className="card card-body">
                                <div className="content_sub">Inline</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="location_type" className="card-input-element d-none" value="floating" onChange={handleLocationTypeChange} checked={locationType === "floating"} />
                            <div className="card card-body">
                                <div className="content_sub">Floating</div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <p>Position</p>
                    <div className="left-cnater-right-button mb-0 p-2 mt-0">
                        <label className="card-radio-btn">
                            <input type="radio" name="position_type" className="card-input-element d-none" value="left" onChange={handlePositionTypeChange} checked={positionType === "left"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3.5 2.733a.6.6 0 0 1 .592.503l.008.097v13.334a.6.6 0 0 1-1.192.097l-.008-.097V3.333a.6.6 0 0 1 .6-.6ZM17.667 8c.46 0 .833.373.833.833v2.334c0 .46-.373.833-.833.833H6.833A.833.833 0 0 1 6 11.167V8.833c0-.46.373-.833.833-.833h10.834Z"></path></svg>
                                </div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="position_type" className="card-input-element d-none" value="middle" onChange={handlePositionTypeChange} checked={positionType === "middle"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 13.567a.6.6 0 0 1 .592.502l.008.098V17.5a.6.6 0 0 1-1.192.097L9.4 17.5v-3.333a.6.6 0 0 1 .6-.6ZM15.833 8c.46 0 .834.373.834.833v2.334c0 .46-.373.833-.834.833H4.167a.833.833 0 0 1-.834-.833V8.833c0-.46.373-.833.834-.833h11.666ZM10 1.9a.6.6 0 0 1 .592.503l.008.097v3.333a.6.6 0 0 1-1.192.098L9.4 5.833V2.5a.6.6 0 0 1 .6-.6Z"></path></svg>
                                </div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="position_type" className="card-input-element d-none" value="right" onChange={handlePositionTypeChange} checked={positionType === "right"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.5 2.733a.6.6 0 0 1 .592.503l.008.097v13.334a.6.6 0 0 1-1.192.097l-.008-.097V3.333a.6.6 0 0 1 .6-.6ZM13.167 8c.46 0 .833.373.833.833v2.334c0 .46-.373.833-.833.833H2.333a.833.833 0 0 1-.833-.833V8.833c0-.46.373-.833.833-.833h10.834Z"></path></svg>
                                    </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayoutTab;